import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBBtn,
  MDBBtnGroup,
} from "mdbreact";
import { Bounce, ToastContainer, toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import AddEditSales from "./AddEditSales";
import ViewSales from "./ViewSales";
import AddEditBackOrder from "./AddEditBackOrder";
import AddNewSales from "./AddNewSales";
import ChargeSummary from "./ChargeSummary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBoxesPacking,
  faCar,
  faCircleExclamation,
  faFileInvoice,
  faMoneyCheck,
  faLock,
  faMagnifyingGlassArrowRight,
  faScrewdriverWrench,
  faSpinner,
  faUser,
  faWandMagicSparkles,
  faPrint,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import Recommendation from "../Recommendation/Recommendation";
import Payment from "../Payments/Payment";
import AddEditSalesMain from "./AddEditSalesMain";

import ChargeInclusion from "../Administrator/ChargeInclusion";
import { AppBar, Box, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import PrintInvoice from "./PrintInvoice";
import ReleaseTicket from "./ReleaseTicket";

const Sales = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  let intTotalSales = useSelector((state) => state.sales.value);
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: theme.palette.background.paper,
    },
  }));
  const classes = useStyles();

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
        className="p-0 m-0"
      >
        {value === index && (
          <Box p={0} m={0}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
  }

  const [rows, setRows] = useState([]);

  const [showPreloader, setPreloader] = useState("normal");
  const [strTransactions, setTransactions] = useState("");
  const [selRow, setSelectedRow] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = (transtype) => {
    setRows([]);

    showAddEdit(!modalAddEdit);

    loadData();
  };

  const toastId = React.useRef(null);

  // const notify = (message) => {
  //   toastId.current = toast.info(message);
  // };

  const notify = (message) => {
    toast(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold blue-text",
    });
  };

  const [bRefresh, setRefresh] = useState(false);

  const refreshGrid = (message) => {
    setRows([]);
    setRefresh(!bRefresh);

    loadData();

    if (new String(message).toString() !== "undefined") {
      console.log("sdsds");
      notify(message);
    } else {
      console.log("undefined message");
    }
  };

  const showResult = (message) => {
    setRefresh(!bRefresh);

    setRows([]);

    // loadData();

    loadData();

    toast.info(message, {
      closeButton: false,
    });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadData() {
    Axios.get(
      props.apiServer + "/transactionslist?parentcode=" + props.parentcode,
      bearer
    )
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
        props.checkTotalSales();
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function ShowDeleted() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("deleted");
    loadData();
  }

  function ShowReturns() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("returns");
    loadData();
  }

  function ShowSales() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("sales");
    loadData();
  }

  function ShowAll() {
    setPreloader("normal");
    setTransactions("");
    loadData();
  }
  const useMountEffect = (functionName) => useEffect(functionName, []);

  // useMountEffect(checkAdminAccess);
  // useMountEffect(loadData);

  useEffect(() => {
    // loadData();
    refreshGrid();
  }, [strTransactions]);

  useEffect(() => {
    // loadData();
    refreshGrid();
  }, [props.code]);

  useEffect(() => {
    // loadData();
    refreshGrid();
  }, [props.parentcode]);

  useEffect(() => {
    // loadData();
    refreshGrid();
  }, [value]);

  useEffect(() => {
    // console.log("price changed");
    setValue(0);
  }, [intTotalSales]);

  const TabSales = () => {
    return (
      <>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="on"
          aria-label="scrollable"
          // className="cloudy-knoxville-gradient black-text"
          style={{ borderColor: "white" }}
          className="pb-0 mb-0"
        >
          <Tab
            label={
              <a className="blue-text font-weight-bold">
                Charge
                <br />
                Summary
              </a>
            }
            icon={
              <FontAwesomeIcon
                icon={faFileInvoice}
                size="4x"
                className="blue-text"
              />
            }
            {...a11yProps(0)}
          />
          <Tab
            label={
              <a className="blue-text font-weight-bold">
                Ticket
                <br />
                Details
              </a>
            }
            icon={
              <FontAwesomeIcon
                icon={faScrewdriverWrench}
                size="4x"
                className="blue-text"
              />
            }
            {...a11yProps(1)}
          />
          <Tab
            label={
              <a className="blue-text font-weight-bold">
                NUTECH
                <br />
                RECOMMENDATION
              </a>
            }
            icon={
              <FontAwesomeIcon
                icon={faWandMagicSparkles}
                size="4x"
                className="blue-text"
              />
            }
            {...a11yProps(2)}
          />
          <Tab
            label={
              <a className="blue-text font-weight-bold">
                CUSTOMER
                <br />
                PAYMENTS
              </a>
            }
            icon={
              <FontAwesomeIcon
                icon={faMoneyCheck}
                size="4x"
                className="blue-text"
              />
            }
            {...a11yProps(3)}
          />
          <Tab
            label={
              <a className="blue-text font-weight-bold">
                INVOICE
                <br />
                GENERATION
              </a>
            }
            icon={
              <FontAwesomeIcon icon={faPrint} size="4x" className="blue-text" />
            }
            {...a11yProps(4)}
          />
          <Tab
            label={
              <a className="blue-text font-weight-bold">
                TICKET
                <br />
                RELEASING
              </a>
            }
            icon={
              <FontAwesomeIcon
                icon={faUserCheck}
                size="4x"
                className="blue-text"
              />
            }
            {...a11yProps(5)}
          />
        </Tabs>
      </>
    );
  };
  return (
    <React.Fragment>
      <MDBRow>
        <MDBCol md="12">
          {showPreloader === "normal" ? (
            <MDBRow>
              <MDBCol md="4"></MDBCol>
              <MDBCol md="4" className="text-center">
                <br />
                <img
                  src={props.deployURL + "/loading.gif"}
                  style={{ width: "300px", textAlign: "center" }}
                  alt="loading"
                />
                <br />
              </MDBCol>
              <MDBCol md="4"></MDBCol>
            </MDBRow>
          ) : (
            <React.Fragment>
              <MDBRow>
                <MDBCol md="8">
                  <div className={classes.root}>
                    {/* <AppBar
                      position="static"
                      color="cloudy-knoxville-gradient black-text"
                      
                      className="mt-4"
                    > */}
                    <TabSales />

                    {/* </AppBar> */}
                    <hr />
                    <TabPanel value={value} index={0}>
                      <ChargeSummary
                        rows={rows}
                        deployURL={props.deployURL}
                        apiServer={props.apiServer}
                        parentcode={props.parentcode}
                        dealercode={props.dealercode}
                        apiServerHybrid={props.apiServerHybrid}
                        toggleModal={toggleAddEdit}
                        refreshGrid={refreshGrid}
                        showResult={showResult}
                        totalSales={props.totalSales}
                        setTotalSales={props.setTotalSales}
                        checkTotalSales={props.checkTotalSales}
                        opencpdnew={props.opencpdnew}
                        discountLimit={props.discountLimit}
                        discountInWeek={props.discountInWeek}
                        setDiscountInWeek={props.setDiscountInWeek}
                        getdiscountinweek={props.getdiscountinweek}
                      ></ChargeSummary>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                      <MDBCard>
                        <AddEditSalesMain
                          deployURL={props.deployURL}
                          apiServer={props.apiServer}
                          code={props.code}
                        ></AddEditSalesMain>
                      </MDBCard>
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                      <Recommendation
                        deployURL={props.deployURL}
                        apiServer={props.apiServer}
                        code="new"
                        parentcode={props.parentcode}
                        dealercode={props.dealercode}
                        returned={false}
                        discountcode={props.discountcode}
                        discounttype={props.discounttype}
                        discountrate={props.discountrate}
                        numberofcharges={rows.length}
                        apiServerHybrid={props.apiServerHybrid}
                        apiServerPOS={props.apiServerPOS}
                        toggleModal={toggleAddEdit}
                        refreshGrid={refreshGrid}
                      ></Recommendation>
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                      <Payment
                        deployURL={props.deployURL}
                        apiServer={props.apiServer}
                        code="new"
                        parentcode={props.parentcode}
                        dealercode={props.dealercode}
                        returned={false}
                        discountcode={props.discountcode}
                        discounttype={props.discounttype}
                        discountrate={props.discountrate}
                        numberofcharges={rows.length}
                        apiServerHybrid={props.apiServerHybrid}
                        apiServerPOS={props.apiServerPOS}
                        checkTotalSales={props.checkTotalSales}
                        toggleModal={toggleAddEdit}
                        refreshSales={refreshGrid}
                      ></Payment>
                      {/* <Recommendation
                        deployURL={props.deployURL}
                        apiServer={props.apiServer}
                        code="new"
                        parentcode={props.parentcode}
                        dealercode={props.dealercode}
                        returned={false}
                        discountcode={props.discountcode}
                        discounttype={props.discounttype}
                        discountrate={props.discountrate}
                        numberofcharges={rows.length}
                        apiServerHybrid={props.apiServerHybrid}
                        apiServerPOS={props.apiServerPOS}
                        toggleModal={toggleAddEdit}
                        refreshGrid={refreshGrid}
                      ></Recommendation> */}
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                      <PrintInvoice
                        deployURL={props.deployURL}
                        apiServer={props.apiServer}
                        code="new"
                        parentcode={props.parentcode}
                        dealercode={props.dealercode}
                        returned={false}
                        discountcode={props.discountcode}
                        discounttype={props.discounttype}
                        discountrate={props.discountrate}
                        numberofcharges={rows.length}
                        apiServerHybrid={props.apiServerHybrid}
                        apiServerPOS={props.apiServerPOS}
                        toggleModal={toggleAddEdit}
                        refreshGrid={refreshGrid}
                      ></PrintInvoice>
                    </TabPanel>
                    <TabPanel value={value} index={5}>
                      <ReleaseTicket
                        deployURL={props.deployURL}
                        apiServer={props.apiServer}
                        code="new"
                        parentcode={props.parentcode}
                        dealercode={props.dealercode}
                        returned={false}
                        discountcode={props.discountcode}
                        discounttype={props.discounttype}
                        discountrate={props.discountrate}
                        numberofcharges={rows.length}
                        apiServerHybrid={props.apiServerHybrid}
                        apiServerPOS={props.apiServerPOS}
                        toggleModal={toggleAddEdit}
                        refreshGrid={refreshGrid}
                      ></ReleaseTicket>
                    </TabPanel>
                    <hr />
                    <TabSales />
                  </div>
                </MDBCol>
                <MDBCol md="4">
                  <AddNewSales
                    deployURL={props.deployURL}
                    apiServer={props.apiServer}
                    code="new"
                    parentcode={props.parentcode}
                    dealercode={props.dealercode}
                    returned={false}
                    discountcode={props.discountcode}
                    discounttype={props.discounttype}
                    discountrate={props.discountrate}
                    numberofcharges={rows.length}
                    apiServerHybrid={props.apiServerHybrid}
                    apiServerPOS={props.apiServerPOS}
                    toggleModal={toggleAddEdit}
                    // refreshGrid={refreshGrid}
                    refreshGrid={refreshGrid}
                    //  refreshSalesMain={props.refreshGrid}

                    totalSales={props.totalSales}
                    setTotalSales={props.setTotalSales}
                    checkTotalSales={props.checkTotalSales}
                    opencpdnew={props.opencpdnew}
                    discountLimit={props.discountLimit}
                    discountInWeek={props.discountInWeek}
                    setDiscountInWeek={props.setDiscountInWeek}
                    getdiscountinweek={props.getdiscountinweek}
                  ></AddNewSales>
                </MDBCol>
              </MDBRow>
            </React.Fragment>
          )}
        </MDBCol>
      </MDBRow>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      ></ToastContainer>
    </React.Fragment>
  );
};

export default Sales;
